import { useState } from 'react';
import { useFilterDispatch } from '../../../contexts/filter-context';
import { Input } from '../../widgets/input/input';
import { ReactComponent as SearchIcon } from '../../../assets/search.svg';
import './search.css';
import * as cn from 'classnames';

export const Search = () => {
  const [searchValue, setSearchValue] = useState('');
  const dispatchFilter = useFilterDispatch();

  const handleSearchInputChanged = (value) => {
    setSearchValue(value);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    dispatchFilter({ type: 'search-set', search: searchValue });
  };

  const handleClear = async (e) => {
    setSearchValue('');
    dispatchFilter({ type: 'search-set', search: '' });
  };

  return (
    <div className="search-widget">
      <form onSubmit={handleSearch}>
        <Input onInputChanged={handleSearchInputChanged} icon={<SearchIcon />} hasClearIcon={true} onClear={handleClear}></Input>
      </form>
    </div>
  );
};
